import { render, staticRenderFns } from "./PropertyReport.vue?vue&type=template&id=23de192e&scoped=true&"
import script from "./PropertyReport.vue?vue&type=script&lang=ts&"
export * from "./PropertyReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de192e",
  null
  
)

export default component.exports